import styled from 'styled-components';

export const dateStyles = {
  Date: styled.span``,
};
